import React from "react";
import { Button, Form, Input } from "antd";
import { API_AUTH_AGENT } from "../../store/slices/authSlice/authSlice";
import { useAppDispatch } from "../../store/reduxHooks";
import { ruleRequired } from "../../constants/rules/RulesConstantsForms";

type FieldType = {
  email: string;
  password: string;
};
const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const onFinish = async (values: FieldType) => {
    dispatch(API_AUTH_AGENT(values));
  };

  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      onFinish={onFinish}
      layout="vertical"
      //autoComplete="on"
    >
      <Form.Item<FieldType>
        label="Email"
        name="email"
        rules={[
          ruleRequired,
          { type: "email", message: "Введите корректый Email" },
        ]}
        style={{ marginBottom: "10px" }}
      >
        <Input placeholder="Введите email" autoComplete="username" />
      </Form.Item>

      <Form.Item<FieldType>
        label="Пароль"
        name="password"
        rules={[ruleRequired]}
      >
        <Input.Password
          placeholder="Введите пароль"
          autoComplete="current-password"
        />
      </Form.Item>
      <Button
        type="primary"
        style={{ width: "100%", marginBottom: "16px" }}
        onClick={() => form.submit()}
      >
        Войти
      </Button>
    </Form>
  );
};
export default Login;
